import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react"; import Select from 'react-select'
import { useTranslation } from "react-i18next";
import { useAuthState } from "../../Helper/Context";
import { UserGenderDDLAPI } from "../../Redux/DDLSlice";


export const ShiftCommanDDL = (props) => {
    const { ShiftID, setShiftID, Flag, data, IsPost, Language, StarMark, ApiFlag } = props

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const [ShiftDDLData, setShiftDDLData] = useState([])

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            Flag: ApiFlag,
            Lanaguage: Language.Label ? Language.Label : Language,
            token: token,
            setShiftDDLData: setShiftDDLData
        }
        dispatch(UserGenderDDLAPI({ data }))
    }, [IsPost, Language.Label])

    const { DDLData } = useSelector(state => state.UserGenderDDLData)

    useEffect(() => {
        handleDDL()
    }, [ShiftDDLData])

    const handleDDL = () => {
        if (ShiftDDLData && ShiftDDLData.length > 0) {
            let list = ShiftDDLData.map((item, index) => ({
                value: item.shiftID,
                label: item.shift_Name,
            }))

            setShiftID({
                DDL: list,
                // ID: Flag == 'Update' ? data?.m_Indicator_ActiveID : 0,
                // Label: Flag == 'Update' ? data?.indicatorName : "Select...",
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setShiftID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block fs-8 pb-2" htmlFor="Designation">{t('EncroachmentDashboard.Shift')} :</label>
            <Select
                id='ShiftID'
                isClearable={true}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={150}
                value={{ value: ShiftID.ID, label: ShiftID.Label }}
                onChange={(e) => {
                    e ?
                        setShiftID({ ...ShiftID, ID: e.value, Label: e.label })
                        :
                        setShiftID({ ...ShiftID, ID: 0, Label: "Select..." })

                }}
                options={ShiftID.DDL}
            />
        </div>
    )
}